import React, { useState, useEffect } from "react";
import icons from "../../icons.config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faLinkedin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import { fetchAboutUsData } from "../../Providers/aboutUsProvider";
import { IMAGE_BASE_URL } from "../../api-urls";

function AboutUs() {
  const [aboutData, setAboutData] = useState("");
  const [whyChooseUs, setWhyChooseUs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const { aboutData, error } = await fetchAboutUsData();
      if (aboutData) {
        setAboutData(aboutData);
        setWhyChooseUs(aboutData.whyChooseUsData);
      }
      setError(error);
      setLoading(false);
    };

    getData();
  }, []);

  const imageList = aboutData.aboutUsData?.images_of_founder
    ? aboutData.aboutUsData.images_of_founder.map((img) => ({
        original: IMAGE_BASE_URL + img,
        gImage: IMAGE_BASE_URL + img,
      }))
    : [];

  useEffect(() => {
    if (imageList.length === 0) return;

    const updateImages = () => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
        setIsFading(false);
      }, 900);
    };

    const interval = setInterval(updateImages, 3000);
    return () => clearInterval(interval);
  }, [imageList]);

  if (loading) return <p className="text-center">Loading...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;
  if (!aboutData.aboutUsData) return <p className="text-center">No data available</p>;

  const whyChooseUsData = whyChooseUs.map((item) => ({
    icon: IMAGE_BASE_URL + item.image,
    title: item.title,
    description: "We offer high-quality services to meet customer needs.", // Update if API provides a description
  }));

  return (
    <>
      <Navbar />
      <div className="px-6 bg-tertiary overflow-hidden py-2 xl:py-2">
        <div className="relative lg:left-[83%] left-[73%] md:left-[80%] top-7 lg:-top-7 xl:-top-7 z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-32 md:w-48 lg:w-1/5" />
        </div>
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12 relative lg:bottom-24">
          <h4 className="lg:hidden text-3xl text-primary1 font-normal mb-3 lg:order-1">ABOUT US</h4>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-center relative lg:left-16 xl:left-28">
            <div className="w-[100%] lg:w-[120%] h-full lg:h-[350px] xl:h-[400px] 2xl:h-[450px] px-5 lg:px-0">
              {aboutData?.aboutUsData?.about_us_image ? (
                aboutData.aboutUsData.about_us_image.endsWith(".mp4") ||
                aboutData.aboutUsData.about_us_image.endsWith(".webm") ||
                aboutData.aboutUsData.about_us_image.endsWith(".ogg") ? (
                  <video
                    src={IMAGE_BASE_URL + aboutData.aboutUsData.about_us_image}
                    className="w-full h-full object-cover"
                    autoPlay
                    muted
                    loop
                  />
                ) : (
                  <img
                    src={IMAGE_BASE_URL + aboutData.aboutUsData.about_us_image}
                    alt="Description of Image"
                    className="w-full h-full object-cover"
                  />
                )
              ) : (
                <img
                  src="/fallback-image.jpg"
                  alt="Fallback Image"
                  className="w-full h-full object-cover"
                />
              )}
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col items-start text-left relative lg:left-20 xl:left-28 pl-5 lg:pl-0 pr-5 lg:pr-1">
            <h4 className="hidden lg:block text-2xl lg:text-lg xl:text-3xl text-primary1 font-normal mb-2 xl:mb-3 lg:order-1">
              ABOUT US
            </h4>
            <h2 className="text-4xl md:text-5xl lg:text-3xl xl:text-6xl font-normal font-outfit text-primary1 lg:order-2 mt-10 lg:-mt-2">
              DIKOST
            </h2>
            <h5 className="text-lg md:text-xl lg:order-3 font-belleza font-normal text-hcolor">
              Exquisite Fit, Premium Style
            </h5>
            <h3 className="text-2xl md:text-3xl text-primary1 font-outfit font-light lg:order-4 mt-5 lg:mt-0 xl:mt-5">
              STORY OF DIKOST
            </h3>
            <p className="text-sm text-hcolor lg:order-5 max-w-md md:max-w-xl lg:max-w-md 2xl:max-w-lg mt-3">
              {aboutData.aboutUsData.story_of_dikost}
            </p>
            <div className="space-x-6 text-primary1 lg:order-6 absolute lg:-bottom-[13%] xl:-bottom-[10%] 2xl:-bottom-[21%]">
              <a href={aboutData.aboutUsData.app_whatsapp_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a href={aboutData.aboutUsData.app_instagram_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href={aboutData.aboutUsData.app_facebook_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href={aboutData.aboutUsData.app_linkedIn_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-tertiary place-items-center pt-12 lg:pt-20 lg:pb-0 relative top-0 justify-center z-10 overflow-x-hidden">
        <div className="relative bottom-4 md:bottom-10 lg:-top-10 left-[5%] md:-left-[25%] lg:-left-[14%] z-20 h-10 py-3">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-16 md:w-20 lg:w-28" />
        </div>
        <h2 className="text-center text-3xl font-outfit font-light relative bottom-1 lg:bottom-5 mb-6 py-2">
          {aboutData.aboutUsData.title || "QUALITY WE OFFER"}
        </h2>
        <div className="relative place-items-center bg-primary2 lg:mx-20 xl:mx-32 lg:w-[86%] xl:w-[82%] pb-16 lg:py-12 xl:py-10">
          <div
            className="absolute inset-0 z-10 bg-cover h-[70%] bg-center pointer-events-none"
            style={{
              backgroundImage: `url(${icons.brandPattern})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              top: "4%",
              left: "1%",
              right: "1%",
              bottom: "4%",
              width: "96%",
              height: "92%",
            }}
          />
          <div className="flex flex-col-reverse lg:flex-row items-center w-full px-8">
            <div className="flex flex-col items-center w-full lg:w-1/2 xl:w-2/3 lg:px-5">
              <div className="grid grid-cols-3 gap-8 md:gap-24 lg:gap-20 xl:gap-24">
                {whyChooseUsData.map((item, index) => (
                  <div key={index} className="flex flex-col items-center relative">
                    <div className="bg-primary1 shadow-lg rounded-full h-20 w-20 md:w-24 md:h-24 lg:h-28 lg:w-28 xl:h-32 xl:w-32 mb-4 relative flex items-center justify-center overflow-hidden">
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="absolute h-full w-full object-cover"
                      />
                    </div>
                    <h3 className="text-md md:text-xl lg:text-lg xl:text-xl lg:pr-2 xl:pr-0 font-outfit font-normal mt-1 mb-10 lg:mb-7 xl:mb-4 2xl:mb-10 text-hcolor md:text-center lg:text-start md:ml-2 lg:mt-0 text-nowrap">
                      {item.title}
                    </h3>
                  </div>
                ))}
              </div>
              <p className="font-poppins font-normal text-md xl:text-base text-center text-primary1 mt-2 lg:-mt-5 xl:mt-2 px-2 md:px-3 lg:px-0 xl:px-3">
                {aboutData.aboutUsData.description}
              </p>
            </div>

            <div className="flex justify-center items-center w-full lg:w-1/2 xl:w-1/3 my-10 lg:pb-1 2xl:pb-2 lg:my-0 z-20">
              <div className="w-80 h-80 md:w-72 md:h-72 lg:w-80 lg:h-80 xl:w-96 xl:h-96 flex justify-center items-center">
                {aboutData?.aboutUsData?.file ? (
                  aboutData.aboutUsData.file.endsWith(".mp4") ||
                  aboutData.aboutUsData.file.endsWith(".webm") ||
                  aboutData.aboutUsData.file.endsWith(".ogg") ? (
                    <video
                      src={IMAGE_BASE_URL + aboutData.aboutUsData.file}
                      className="w-full h-full object-cover"
                      autoPlay
                      muted
                      loop
                    />
                  ) : (
                    <img
                      src={IMAGE_BASE_URL + aboutData.aboutUsData.file}
                      alt="Founder"
                      className="w-full h-full object-cover"
                    />
                  )
                ) : (
                  <img
                    src="/fallback-image.jpg"
                    alt="Fallback Image"
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative bg-tertiary pt-[5%] pb-[15%] md:py-[12%] xl:pt-[10%] xl:pb-[0%] z-1 top-0 md:px-8 xl:px-2 overflow-hidden">
        <div className="relative top-2 md:top-8 lg:-top-7 xl:-top-2 left-[5%] lg:left-[10%] xl:left-[25%] z-20 h-10">
          <img src={icons.blogFlower2} alt="Doodle Left" className="w-16 md:w-20" />
        </div>
        <h3 className="text-xl md:text-3xl lg:text-4xl flex justify-center font-outfit font-light mb-4 text-hcolor relative bottom-5 md:bottom-12 lg:bottom-6">
          THE VISIONARY BEHIND DIKOST
        </h3>

        <div className="flex justify-center items-center lg:hidden z-20">
          <div className="w-[77%] md:w-[95%] h-auto relative">
            <img
              src={imageList[currentIndex].original}
              alt="Founder Image"
              className="w-full h-full object-cover animate-dissolve transition-opacity duration-500"
            />
          </div>
        </div>

        <div className="container relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-center z-20 mt-16 lg:mt-0 lg:px-4 xl:px-14 2xl:px-20 xl:left-8 2xl:right-20">
          <div className="grid-cols-1 lg:grid-cols-2 gap-4 w-full hidden lg:grid relative top-10">
            <div className="col-span-1 flex justify-center relative lg:top-5 lg:left-10 2xl:top-6 2xl:-left-5 z-10">
              <div className="w-[65%] h-[95%] lg:w-[110%] xl:w-[97%] 2xl:w-[75%] overflow-hidden">
                <img
                  src={imageList[currentIndex].original}
                  alt="Founder Image"
                  className="w-full h-full object-cover transition-opacity duration-500"
                />
              </div>
            </div>
            <div className="col-span-1 flex justify-center relative 2xl:right-16">
              <div className="w-[65%] h-[95%] lg:w-[110%] xl:w-[97%] 2xl:w-[75%] overflow-hidden">
                <img
                  src={imageList[(currentIndex + 1) % imageList.length].gImage}
                  alt="Founder Image"
                  className="w-full h-full object-cover transition-opacity duration-500"
                />
              </div>
            </div>
            <div className="col-span-2 flex justify-center relative lg:bottom-14 lg:left-7 2xl:bottom-10 2xl:left-8">
              <div className="w-[33%] h-[90%] lg:w-[56%] xl:w-[53%] 2xl:w-[42%] overflow-hidden">
                <img
                  src={imageList[(currentIndex + 2) % imageList.length].gImage}
                  alt="Founder Image"
                  className="w-full h-full object-cover transition-opacity duration-500"
                />
              </div>
            </div>
          </div>

          <div className="text-center relative px-6 lg:px-0 mx-auto lg:mx-0 lg:left-8 xl:left-11 2xl:-left-16">
            <h2 className="text-3xl md:text-4xl xl:text-5xl font-outfit font-medium text-white mb-12 lg:mb-6 2xl:mb-12">
              JIYA BENIWAL
            </h2>
            <h5 className="text-md font-poppins font-medium mb-4 text-white">
              “Celebrate Individuality with Sophistication and Style”
            </h5>
            <p className="font-poppins font-light text-hcolor text-sm md:text-base xl:text-lg 2xl:text-base">
              {aboutData.aboutUsData.about_founder}
            </p>
            <div className="flex space-x-6 text-primary1 mt-5 xl:mt-7 2xl:mt-10 justify-center">
              <a href={aboutData.aboutUsData.founder_whatsapp_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a href={aboutData.aboutUsData.founder_instagram_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href={aboutData.aboutUsData.founder_facebook_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href={aboutData.aboutUsData.founder_linkedIn_url} target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-hcolor">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <FooterDoodles />
      <Footer />
    </>
  );
}

export default AboutUs;




// import {React,useState,useEffect} from 'react';
// import images from '../../images.config';
// import icons from "../../icons.config";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFacebookF, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import Navbar from '../Navbar/navbar';
// import Footer from '../Footer/footer';
// import FooterDoodles from '../Footer/footerDoodles';
// //import { useNavigate } from 'react-router-dom';

// function AboutUs() {
//   const aboutUsData = [
//     {
//       icon: icons.customFit,
//       title: 'Custom Fit',
//       description: 'We offer a wide range of high-quality products that meet the needs of our customers.',
//     },
//     {
//       icon: icons.luxuryFabrics,
//       title: 'Luxury Fabrics',
//       description: 'Our customers are our priority, and we strive to provide excellent service and support.',
//     },
//     {
//       icon: icons.modernStyles,
//       title: 'Modern Styles',
//       description: 'Our team consists of experts who are dedicated to helping you find the right solutions.',
//     },
//   ];

//   const imageList = [
//     { original: images.founder1, gImage: images.founder1g },
//      { original: images.founder2, gImage: images.founder2g },
//      { original: images.founder3, gImage: images.founder3g },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isFading, setIsFading] = useState(false);
  

//   const updateImages = () => {
//     setIsFading(true); // Start fading

//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
//       setIsFading(false); // End fading
//     }, 900); // Duration of the fade effect
//   };

//   useEffect(() => {
//     const interval = setInterval(updateImages, 3000); // Change every 3 seconds
//     return () => clearInterval(interval);
//   }, []);
//   return (
//     <>
//     <Navbar/>
//     <div className="px-6 bg-tertiary overflow-hidden py-2 xl:py-2">
//     <div className="relative lg:left-[83%] left-[73%] md:left-[80%] top-7 lg:-top-7 xl:-top-7 z-10">
//           <img src={icons.trendCircles} alt="Doodle Left" className="w-32 md:w-48 lg:w-1/5" />
//         </div>
//   {/* Responsive flex for large screens */}
//   <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12 relative lg:bottom-24">
//   <h4 className="lg:hidden text-3xl text-primary1 font-normal mb-3 lg:order-1">
//         ABOUT US
//       </h4>

//     {/* Left section for the image (appears first in lg and above) */}
//     <div className="w-full lg:w-1/2 flex justify-center lg:justify-center relative lg:left-16 xl:left-28">
//     <div className='w-[120%] h-full px-5 lg:px-0'>
//     <img
//         src={images.aboutImg}
//         alt="Description of Image"
//         className="lg:h-[170%]"
//       />
//     </div>
      
//     </div>

//     {/* Right section for heading, description, and icons */}
//     <div className="w-full lg:w-1/2 flex flex-col items-start text-left relative lg:left-20 xl:left-28 pl-5 lg:pl-0 pr-5 lg:pr-1">
      
//       {/* Small Heading (appears at top on small and medium screens) */}
//       <h4 className="hidden lg:block text-2xl lg:text-lg xl:text-3xl text-primary1 font-normal mb-2 xl:mb-3 lg:order-1">
//         ABOUT US
//       </h4>

//       {/* Main Heading */}
//       <h2 className="text-4xl md:text-5xl lg:text-3xl  xl:text-6xl font-normal font-outfit text-primary1 lg:order-2 mt-10 lg:-mt-2">
//         DIKOST
//       </h2>
//       <h5 className='text-lg md:text-xl lg:order-3 font-belleza font-normal text-hcolor'>Exquisite Fit, Premium Style</h5>

//       <h3 className='text-2xl md:text-3xl text-primary1 font-outfit font-light lg:order-4 mt-5 lg:mt-0 xl:mt-5'>
//          STORY OF DIKOST
//       </h3>

//       {/* Description */}
//       <p className="text-sm  xl:text-base  text-hcolor lg:order-5 max-w-sm xl:max-w-base 2xl:max-w-lg mt-3">
//       Discover the latest fashion trends curated just for you. From timeless classics to cutting-edge designs, Dikost brings you trendsetting styles that blend elegance with modern flair. Whether you're looking for statement pieces or everyday essentials, our collection keeps your wardrobe on point and perfectly tailored to your taste. Discover the latest fashion trends curated just for you.
//       </p>

//       {/* FontAwesome icons (Social Links or NavLinks) */}
//       <div className="space-x-6 text-primary1 lg:order-6 absolute lg:-bottom-[18%] xl:-bottom-[14%] 2xl:-bottom-[25%]">
            
//             <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//               <FontAwesomeIcon icon={faWhatsapp} />
//             </a>
           
//             <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//               <FontAwesomeIcon icon={faInstagram} />
//             </a>
//             <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//               <FontAwesomeIcon icon={faFacebookF} />
//             </a>
//             <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//               <FontAwesomeIcon icon={faLinkedin} />
//             </a>
          
             
//           </div>
//     </div>
//   </div>
// </div>
//     <div className='bg-tertiary  place-items-center  pt-12 lg:pt-20 lg:pb-0 relative top-0  justify-center z-10 overflow-x-hidden'>
//     <div className="relative bottom-4 md:bottom-10 lg:-top-10 left-[5%] md:-left-[25%] lg:-left-[14%] z-20 h-10 py-3">
//           <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-16 md:w-20 lg:w-28 " />
//         </div>
//         <h2 className="text-center text-3xl font-outfit font-light relative bottom-1 lg:bottom-5 mb-6 py-2 ">
//            QUALITY WE OFFER
//         </h2>
//    <div className="relative place-items-center bg-primary2  lg:mx-20 xl:mx-32 lg:w-[86%] xl:w-[82%] pb-16 lg:py-12 xl:py-10 ">
//   <div
//     className="absolute inset-0 z-10 bg-cover h-[70%] bg-center pointer-events-none"
//     style={{
//       backgroundImage: `url(${icons.brandPattern})`,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       top: '4%',
//       left: '1%',
//       right: '1%',
//       bottom: '4%',
//       width: '96%',
//       height: '92%',
//     }}
//   />
//   <div className="flex flex-col-reverse lg:flex-row items-center w-full px-8 ">
//     {/* Left section with aboutUsData.map */}
//     <div className="flex flex-col items-center w-full lg:w-1/2 xl:w-2/3  lg:px-5">
//       <div className="grid grid-cols-3 gap-8 md:gap-24 lg:gap-20 xl:gap-24 ">
//         {aboutUsData.map((item, index) => (
//           <div key={index} className="flex flex-col items-center relative">
//             {/* Circular Background */}
//             <div className="bg-primary1 shadow-lg rounded-full h-20 w-20 md:w-24 md:h-24 lg:h-24  lg:w-24 xl:h-28 xl:w-28 mb-4 relative flex items-center justify-center">
//               {/* Icon placed inside the circle */}
//               <img src={item.icon} alt={item.title} className=" whitespace-nowrap" />
//             </div>
//             {/* Text Content */}
//             <h3 className="text-md md:text-xl lg:text-lg xl:text-xl lg:pr-2 xl:pr-0 font-outfit font-normal mt-1 mb-10 lg:mb-7 xl:mb-4 2xl:mb-10 text-hcolor md:text-center lg:text-start md:ml-2 lg:mt-0 text-nowrap">
//               {item.title}
//             </h3>
//           </div>
//         ))}
//       </div>

//       <p className="font-poppins font-normal text-md  xl:text-base text-center text-primary1 mt-2 lg:-mt-5 xl:mt-2 px-2 md:px-3 lg:px-0 xl:px-3">
//         At Dikost, we redefine fashion with perfect fits and innovative style. Our customizable sizes are crafted to celebrate your individuality, making every outfit feel like it was made just for you. We use highest- quality, premium fabrics blending luxury with comfort, ensuring you never have to compromise on style. At Dikost, we redefine fashion with perfect fits and innovative style. Our customizable sizes are crafted to celebrate your individuality, making every outfit feel like it was made just for you. We use highest- quality, premium fabrics blending luxury with comfort, ensuring you never have to compromise on style.
//       </p>
      
//     </div>

//    {/* Right section with image */}
// <div className="flex justify-center items-center w-full lg:w-1/2 xl:w-1/3  my-10 lg:pb-1 2xl:pb-8 lg:my-0 z-20">
//   <div className="w-[90%] h-full md:w-[60%] md:h-[70%] flex justify-center items-center  lg:w-[95%] lg:h-[95%] ">
//     <img src={images.aboutFabric} alt="Founder" className="" />
//   </div>
// </div>

//   </div>
// </div>
// </div>
//     <div className="relative bg-tertiary pt-[5%] pb-[15%] md:py-[12%]   xl:pt-[10%] xl:pb-[0%]  z-1 top-0 md:px-8 xl:px-2 overflow-hidden">
//     <div className="relative  top-2 md:top-8 lg:-top-7 xl:-top-2 left-[5%] lg:left-[10%] xl:left-[25%] z-20 h-10">
//           <img src={icons.blogFlower2} alt="Doodle Left" className="w-16 md:w-20 " />
//         </div>
      
//       {/* Pattern Overlay */}
//       {/* <div
//         className="absolute inset-0 z-10 bg-cover h-[90%] bg-center pointer-events-none "
//         style={{
//           backgroundImage: `url(${icons.brandPattern})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           top: '4%',
//           left: '3%',
//           right: '3%',
//           bottom: '4%',
//           width: '94%',
//           height: '92%',
         
//         }}
//       /> */}
//       <div className=''>
//       <h3 className='text-xl md:text-3xl lg:text-4xl flex  justify-center font-outfit font-light mb-4 text-hcolor relative bottom-5 md:bottom-12 lg:bottom-6 '>THE VISIONARY BEHIND DIKOST</h3>
//        {/* Centered image for small and medium screens - shows only one image */}
//        <div className=" flex justify-center items-center lg:hidden z-20">
//             <img
//               src={imageList[currentIndex].original} // Show the original image for small screens
//               alt="Founder Image"
//               className="w-[77%] md:w-[95%] h-auto object-cover animate-dissolve relative transition-opacity duration-500"
//             />
//           </div>
//       {/* Content Section */}
//       <div className="container relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-center z-20 mt-16 lg:mt-0 lg:px-4 xl:px-14 2xl:px-20  xl:left-8  2xl:right-12">
 

//   {/* Images Section - Hidden on small/medium screens */}
//   <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full hidden lg:grid relative top-10">
//     {/* First Image */}
//     <div className="col-span-1 flex justify-center relative lg:top-5 lg:left-10 2xl:top-6 2xl:left-12 z-10">
//       <img
//         src={imageList[currentIndex].original}
//         alt="Founder Image"
//         className={`w-[65%] h-[95%] lg:w-[110%] xl:w-[97%] 2xl:w-[75%] object-cover transition-opacity duration-500 ${
//           isFading ? 'opacity-0' : 'opacity-100'
//         }`}
//       />
//     </div>

//     {/* Second Image */}
//     <div className="col-span-1 flex justify-center relative 2xl:right-16 ">
//       <img
//         src={imageList[(currentIndex + 1) % imageList.length].gImage}
//         alt="Founder Image"
//         className={`w-[65%] h-[95%] lg:w-[110%] xl:w-[97%] 2xl:w-[75%] object-cover transition-opacity duration-500 ${
//           isFading ? 'opacity-0' : 'opacity-100'
//         }`}
//       />
//     </div>

//     {/* Third Image */}
//     <div className="col-span-2 flex justify-center relative lg:bottom-14 lg:left-7 2xl:bottom-10 2xl:left-8">
//       <img
//         src={imageList[(currentIndex + 2) % imageList.length].gImage}
//         alt="Founder Image"
//         className={`w-[33%] h-[90%] lg:w-[56%] xl:w-[53%] 2xl:w-[42%] object-cover transition-opacity duration-500 ${
//           isFading ? 'opacity-0' : 'opacity-100'
//         }`}
//       />
//     </div>
//   </div>
//    {/* Text Section */}
//    <div className="text-center relative px-6 lg:px-0  lg:left-8 xl:left-0">
//     <h2 className="text-3xl md:text-4xl xl:text-5xl font-outfit font-medium text-white mb-12 lg:mb-6 2xl:mb-12">
//       JIYA BENIWAL
//     </h2>
//     <h5 className="text-md font-poppins font-medium mb-4 text-white">
//       “Celebrate Individuality with Sophistication and Style”
//     </h5>
//     <p className="font-poppins font-light text-hcolor text-sm md:text-base   xl:text-lg 2xl:text-base">
//       Our mission is to provide premium, customizable fit that empowers everyone to express their unique identity and style while enjoying the luxury of exquisite fits and premium fabrics. We ensure that Dikost makes you feel comfortable first and confident next.
//     </p>
//     <div className="flex space-x-6 text-primary1 mt-5 xl:mt-7 2xl:mt-10 justify-center">
//       <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//         <FontAwesomeIcon icon={faWhatsapp} />
//       </a>
//       <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//         <FontAwesomeIcon icon={faInstagram} />
//       </a>
//       <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//         <FontAwesomeIcon icon={faFacebookF} />
//       </a>
//       <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:hcolor">
//         <FontAwesomeIcon icon={faLinkedin} />
//       </a>
//     </div>
//   </div>
// </div>

//       {/* </div> */}
//     </div>
//     </div>
//     <FooterDoodles/>
//     <Footer /> 
//     </>
//   )
// }

// export default AboutUs


// 1194 × 834            ipad 11 inch